"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalMoreInfo = void 0;
var modalMoreInfo_1 = require("./modalMoreInfo");
Object.defineProperty(exports, "ModalMoreInfo", { enumerable: true, get: function () { return __importDefault(modalMoreInfo_1).default; } });
